import { CrudMode, FormItem } from '@ohpen/enso-ui';

export const HALF_WIDTH = { span: 12 };

// A collapsed card unmounts its fields and their validation rules with them, so only a read-only form folds.
export const crudSection = (title: string, mode: CrudMode | null | undefined, columns: FormItem[]): FormItem => ({
  title,
  valueType: 'group',
  variant: 'card',
  collapsible: mode === CrudMode.VIEW,
  columns,
});
